/* ═══════════════════════════════════════════════════════════════
   BUYSMARTE MEGA MENU - JavaScript V2
   
   V2 CHANGES:
   - Mobile drill-down navigation (Level 1 → 2 → 3)
   - Tap to navigate deeper, back button to go up
   - Properly shows sub-sub-categories on mobile
   - Better mobile UX
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', initMegaMenu);
  
  function initMegaMenu() {
    const megaMenu = document.querySelector('[data-mega-menu]');
    if (!megaMenu) return;
    
    const trigger = megaMenu.querySelector('[data-mega-trigger]');
    const panel = megaMenu.querySelector('[data-mega-panel]');
    const backdrop = megaMenu.querySelector('[data-mega-backdrop]');
    const closeBtn = megaMenu.querySelector('[data-mega-close]');
    
    if (!trigger || !panel) return;
    
    let hoverTimeout = null;
    let isOpen = false;
    
    const isMobile = () => window.innerWidth < 768;
    
    /* ─── OPEN PANEL ─── */
    function openPanel() {
      panel.hidden = false;
      void panel.offsetWidth;
      
      requestAnimationFrame(() => {
        panel.classList.add('is-open');
        megaMenu.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      });
      
      isOpen = true;
      
      if (isMobile()) {
        document.body.style.overflow = 'hidden';
      }
    }
    
    /* ─── CLOSE PANEL ─── */
    function closePanel() {
      panel.classList.remove('is-open');
      megaMenu.classList.remove('is-active');
      megaMenu.classList.remove('is-mobile-detail');
      megaMenu.classList.remove('is-mobile-subsub');
      trigger.setAttribute('aria-expanded', 'false');
      
      setTimeout(() => {
        if (!isOpen) {
          panel.hidden = true;
        }
      }, 300);
      
      isOpen = false;
      document.body.style.overflow = '';
    }
    
    /* ─── TOGGLE PANEL ─── */
    function togglePanel() {
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    }
    
    /* ─── DESKTOP: HOVER BEHAVIOR ─── */
    trigger.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      clearTimeout(hoverTimeout);
      openPanel();
    });
    
    panel.addEventListener('mouseenter', () => {
      if (isMobile()) return;
      clearTimeout(hoverTimeout);
    });
    
    megaMenu.addEventListener('mouseleave', () => {
      if (isMobile()) return;
      hoverTimeout = setTimeout(closePanel, 250);
    });
    
    /* ─── CLICK TRIGGER ─── */
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      togglePanel();
    });
    
    /* ─── CLOSE BUTTON ─── */
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        
        if (isMobile()) {
          // On mobile, close button has different behavior based on level
          if (megaMenu.classList.contains('is-mobile-subsub')) {
            // Level 3 → Back to Level 2
            megaMenu.classList.remove('is-mobile-subsub');
            return;
          } else if (megaMenu.classList.contains('is-mobile-detail')) {
            // Level 2 → Back to Level 1
            megaMenu.classList.remove('is-mobile-detail');
            return;
          }
        }
        
        // Otherwise close completely
        closePanel();
      });
    }
    
    /* ─── BACKDROP CLICK ─── */
    if (backdrop) {
      backdrop.addEventListener('click', closePanel);
    }
    
    /* ─── ESC KEY ─── */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) {
        closePanel();
        trigger.focus();
      }
    });
    
    /* ─── CLICK OUTSIDE ─── */
    document.addEventListener('click', (e) => {
      if (!megaMenu.contains(e.target) && isOpen) {
        closePanel();
      }
    });
    
    /* ─── CATEGORY HOVER (Sidebar) ─── */
    const categories = megaMenu.querySelectorAll('.bs-mega-menu__category');
    const categoryPanels = megaMenu.querySelectorAll('[data-category-panel]');
    
    categories.forEach((cat) => {
      const catId = cat.dataset.category;
      const link = cat.querySelector('.bs-mega-menu__category-link');
      
      // Hover (desktop)
      cat.addEventListener('mouseenter', () => {
        if (isMobile()) return;
        switchCategory(catId);
      });
      
      // Click - works on both mobile and desktop
      if (link) {
        link.addEventListener('click', (e) => {
          if (isMobile()) {
            const hasContent = megaMenu.querySelector(
              `[data-category-panel="${catId}"]`
            );
            if (hasContent) {
              e.preventDefault();
              switchCategory(catId);
              megaMenu.classList.add('is-mobile-detail');
              megaMenu.classList.remove('is-mobile-subsub');
              // Scroll to top
              panel.scrollTop = 0;
            }
          }
        });
      }
    });
    
    function switchCategory(catId) {
      categories.forEach(c => {
        c.classList.toggle('is-active', c.dataset.category === catId);
      });
      
      categoryPanels.forEach(p => {
        const isMatch = p.dataset.categoryPanel === catId;
        p.hidden = !isMatch;
        p.classList.toggle('is-active', isMatch);
      });
    }
    
    /* ─── SUB-CATEGORY HOVER + CLICK ─── */
    const subcats = megaMenu.querySelectorAll('.bs-mega-menu__subcat[data-subcat]');
    
    subcats.forEach((subcat) => {
      const subcatId = subcat.dataset.subcat;
      const subcatLink = subcat.querySelector('.bs-mega-menu__subcat-link');
      
      // Hover for desktop - shows sub-sub on side
      subcat.addEventListener('mouseenter', () => {
        if (isMobile()) return;
        switchSubcat(subcat, subcatId);
      });
      
      // Click handling
      if (subcatLink) {
        subcatLink.addEventListener('click', (e) => {
          if (isMobile()) {
            // Check if this sub-cat has sub-sub-categories
            const parentContent = subcat.closest('[data-category-panel]');
            const hasSubsub = parentContent && parentContent.querySelector(
              `[data-subsubcat-panel="${subcatId}"]`
            );
            
            if (hasSubsub) {
              // Has sub-sub, prevent navigation, show level 3
              e.preventDefault();
              switchSubcat(subcat, subcatId);
              megaMenu.classList.add('is-mobile-subsub');
              // Scroll to top
              panel.scrollTop = 0;
            }
            // If no sub-sub, allow normal link navigation
          }
        });
      }
    });
    
    function switchSubcat(subcatElement, subcatId) {
      const parentContent = subcatElement.closest('[data-category-panel]');
      if (!parentContent) return;
      
      // Update active state on sub-category siblings
      const siblings = parentContent.querySelectorAll('.bs-mega-menu__subcat');
      siblings.forEach(s => {
        s.classList.toggle('is-active', s.dataset.subcat === subcatId);
      });
      
      // Show matching sub-sub-category panel
      const subsubPanels = parentContent.querySelectorAll('[data-subsubcat-panel]');
      subsubPanels.forEach(p => {
        const isMatch = p.dataset.subsubcatPanel === subcatId;
        p.hidden = !isMatch;
        p.classList.toggle('is-active', isMatch);
      });
    }
    
    /* ─── HANDLE WINDOW RESIZE ─── */
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!isMobile()) {
          // Reset mobile classes when switching to desktop
          megaMenu.classList.remove('is-mobile-detail');
          megaMenu.classList.remove('is-mobile-subsub');
          document.body.style.overflow = '';
        }
      }, 100);
    });
  }
})();